import React from 'react';
import FormField from './FormField';

const FormTextArea = ({
  name,
  data,
  prop,
  value,
  onChange,
  placeholder,
}: {
  name: string;
  data?: any;
  prop?: string;
  value?: string;
  onChange: (value: string, prop?: string) => void;
  placeholder?: string;
}) => {
  const id = `field-${prop}`;
  return (
    <FormField labelName={name} id={id}>
      <textarea
        id={id}
        onChange={(e) => onChange(e.target.value, prop)}
        value={(data && prop ? data[prop] : value) || ''}
        placeholder={placeholder}
      />
    </FormField>
  );
};

export default FormTextArea;
